"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oneByType = oneByType;
exports.allByType = allByType;
exports.withoutTypes = withoutTypes;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function oneByType(children, Component) {
  return getArray(children).find(elementHasType(Component)) || null;
}

function allByType(children, Component) {
  return getArray(children).filter(elementHasType(Component));
}

function withoutTypes(children) {
  for (var _len = arguments.length, Components = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    Components[_key - 1] = arguments[_key];
  }

  var types = Components.map(getType);
  return getArray(children).filter(function (child) {
    return !types.includes(child.type);
  });
}

function getArray(children) {
  var array = _react["default"].Children.toArray(children);

  if (!_react["default"].Fragment) return array;
  return array.flatMap(function (child) {
    var isFragment = elementHasType(_react["default"].Fragment)(child);
    return isFragment ? getArray(child.props.children) : child;
  });
}

function elementHasType(Component) {
  var type = getType(Component);
  return function (element) {
    return element.type === type;
  };
}

function getType(Component) {
  var original = console.error;

  console.error = function () {};

  var element = /*#__PURE__*/_react["default"].createElement(Component);

  console.error = original;
  return element.type;
}